import Vue from 'vue'
import { isNull } from 'lodash'

export default {
  namespaced: true,

  state: {
    percent: 0,
    canSuccess: true,
    show: false
  },

  actions: {
    start({ state, dispatch, commit }) {
      commit('SHOW')
      this._timer = setInterval(() => {
        commit('INCREASE_PERCENT')
        if (state.percent > 95) {
          dispatch('clearTimer')
        }
      }, 200)
    },

    finish({ state, dispatch, commit }, { failed } = { failed: false }) {
      if (!state.show) {
        return
      }
      commit('INCREASE_PERCENT', 100)
      if (failed) {
        commit('FAILED')
      }
      dispatch('hide')
    },

    hide({ state, dispatch, commit }) {
      dispatch('clearTimer')
      setTimeout(() => {
        commit('HIDE')
        Vue.nextTick(() => {
          setTimeout(() => {
            commit('INCREASE_PERCENT', 0)
            commit('SUCCESSED')
          }, 200)
        })
      }, 500)
    },

    clearTimer() {
      window.clearInterval(this._timer)
      this._timer = null
    }
  },

  mutations: {
    SHOW(state) {
      state.show = true
    },

    HIDE(state) {
      state.show = false
    },

    INCREASE_PERCENT(state, n) {
      if (isNull(n)) {
        state.percent += 1
        return
      }
      state.percent = 100
    },

    SUCCESSED(state) {
      state.canSuccess = true
    },

    FAILED(state) {
      state.canSuccess = false
    }
  },

  getters: {
    current(state) {
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/progress.js